var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Thêm khoản thu học sinh hàng loạt",
        size: "lg",
        "use-panel": false,
        top: "6vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "sk-dialog__footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { type: "danger", plain: "" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("Hủy")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-save",
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.handleSubmit },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v(" Thêm khoản thu\n      "),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "sk-dialog-content",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.formRules,
            "label-width": "170px",
            "label-position": "left",
          },
        },
        [
          _c("div", { staticClass: "sk-panel mb-4" }, [
            _c("div", { staticClass: "sk-panel-head" }, [
              _c("div", { staticClass: "sk-panel-icon" }, [
                _c("i", { staticClass: "el-icon-office-building" }),
              ]),
              _c("div", [
                _c("p", { staticClass: "sk-panel-title" }, [
                  _vm._v("Phạm vi áp dụng khoản thu"),
                ]),
                _c("p", { staticClass: "sk-panel-subtitle" }, [
                  _vm._v(
                    "Chi tiết phạm vi áp dụng khoản thu (không thể chỉnh sửa)"
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "abrd-scope-container" }, [
              _c("div", { staticClass: "abrd-scope-item" }, [
                _c("span", { staticClass: "abrd-scope-label" }, [
                  _vm._v("Đối tượng:"),
                ]),
                _c("span", { staticClass: "abrd-scope-value" }, [
                  _vm._v(_vm._s(_vm.scopeData.targetName || "—")),
                ]),
              ]),
              _c("div", { staticClass: "abrd-scope-item" }, [
                _c("span", { staticClass: "abrd-scope-label" }, [
                  _vm._v("Tháng - Năm:"),
                ]),
                _vm.scopeData.month && _vm.scopeData.year
                  ? _c("span", { staticClass: "abrd-scope-value" }, [
                      _vm._v(
                        "Tháng " +
                          _vm._s(_vm.scopeData.month) +
                          "/" +
                          _vm._s(_vm.scopeData.year)
                      ),
                    ])
                  : _c("span", { staticClass: "abrd-scope-value" }, [
                      _vm._v("—"),
                    ]),
              ]),
              _c("div", { staticClass: "abrd-scope-item" }, [
                _c("span", { staticClass: "abrd-scope-label" }, [
                  _vm._v("Đợt thu:"),
                ]),
                _c("span", { staticClass: "abrd-scope-value" }, [
                  _vm._v("Đợt " + _vm._s(_vm.scopeData.turn || 1)),
                ]),
              ]),
              _c("div", { staticClass: "abrd-scope-item" }, [
                _c("span", { staticClass: "abrd-scope-label" }, [
                  _vm._v("Số phiếu đang hiển thị:"),
                ]),
                _c("span", { staticClass: "abrd-scope-value" }, [
                  _vm._v(
                    _vm._s(_vm.scopeData.invoiceCount || 0) + " phiếu thu"
                  ),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "sk-panel mb-4" },
            [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c(
                  "div",
                  { staticClass: "sk-panel-icon sk-panel-icon--success" },
                  [_c("i", { staticClass: "el-icon-circle-plus-outline" })]
                ),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Chi tiết khoản thu mới"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v(
                      "Thiết lập tên khoản thu, đơn giá, số lượng, giảm giá và mô tả"
                    ),
                  ]),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Tên khoản thu",
                            prop: "revenueName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Nhập tên khoản thu",
                              clearable: "",
                            },
                            model: {
                              value: _vm.dataForm.revenueName,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "revenueName", $$v)
                              },
                              expression: "dataForm.revenueName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Đơn vị tính", prop: "unit" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Chọn hoặc nhập đơn vị",
                              },
                              model: {
                                value: _vm.dataForm.unit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataForm, "unit", $$v)
                                },
                                expression: "dataForm.unit",
                              },
                            },
                            _vm._l(_vm.unitsList, function (u) {
                              return _c("el-option", {
                                key: u,
                                attrs: { label: u, value: u },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Đơn giá (VNĐ)", prop: "price" } },
                        [
                          _c("el-currency-input", {
                            staticStyle: { width: "100%" },
                            attrs: { options: _vm.currencyOptions },
                            model: {
                              value: _vm.dataForm.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "price", $$v)
                              },
                              expression: "dataForm.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Số lượng", prop: "quantity" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "number",
                              step: _vm.allowDecimal ? 0.01 : 1,
                            },
                            model: {
                              value: _vm.dataForm.quantity,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "quantity", _vm._n($$v))
                              },
                              expression: "dataForm.quantity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Cho phép số thập phân" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "Có",
                              "inactive-text": "Không",
                            },
                            model: {
                              value: _vm.allowDecimal,
                              callback: function ($$v) {
                                _vm.allowDecimal = $$v
                              },
                              expression: "allowDecimal",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Giảm giá", prop: "discount" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.handleDiscountToggle },
                              model: {
                                value: _vm.dataForm.discount,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataForm, "discount", $$v)
                                },
                                expression: "dataForm.discount",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("Có"),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("Không"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Thành tiền (VNĐ)", prop: "amount" },
                        },
                        [
                          _c("el-currency-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.currencyOptions,
                              disabled: "",
                            },
                            model: {
                              value: _vm.displayAmount,
                              callback: function ($$v) {
                                _vm.displayAmount = $$v
                              },
                              expression: "displayAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Thuế suất", prop: "taxPercentage" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "Chọn thuế suất",
                                clearable: "",
                              },
                              on: { change: _vm.handleTaxChange },
                              model: {
                                value: _vm.dataForm.taxPercentage,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataForm, "taxPercentage", $$v)
                                },
                                expression: "dataForm.taxPercentage",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "Không chịu thuế", value: -2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "Không kê khai", value: -1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "0%", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "5%", value: 5 },
                              }),
                              _c("el-option", {
                                attrs: { label: "8%", value: 8 },
                              }),
                              _c("el-option", {
                                attrs: { label: "10%", value: 10 },
                              }),
                              _c("el-option", {
                                attrs: { label: "Khác", value: "other" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  String(_vm.dataForm.taxPercentage) === "other"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Thuế khác (%)",
                                prop: "taxPercentageInput",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  controls: false,
                                  min: 0,
                                  max: 100,
                                  placeholder: "Nhập % thuế",
                                },
                                model: {
                                  value: _vm.dataForm.taxPercentageInput,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "taxPercentageInput",
                                      $$v
                                    )
                                  },
                                  expression: "dataForm.taxPercentageInput",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataForm.discount
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Loại giảm giá",
                                prop: "discountType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "Chọn loại giảm giá" },
                                  on: { change: _vm.handleDiscountTypeChange },
                                  model: {
                                    value: _vm.dataForm.discountType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataForm,
                                        "discountType",
                                        $$v
                                      )
                                    },
                                    expression: "dataForm.discountType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "Phần trăm (%)",
                                      value: "PERCENT",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Số tiền (VNĐ)",
                                      value: "MONEY",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataForm.discount
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "discountValue" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm.dataForm.discountType === "PERCENT"
                                          ? _c("span", [
                                              _vm._v("Phần trăm giảm (%)"),
                                            ])
                                          : _c("span", [
                                              _vm._v("Số tiền giảm (VNĐ)"),
                                            ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                568855960
                              ),
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "edit-discount-container" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "edit-discount-input" },
                                    [
                                      _vm.dataForm.discountType === "MONEY"
                                        ? [
                                            _c("el-currency-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                options: _vm.currencyOptions,
                                              },
                                              model: {
                                                value:
                                                  _vm.dataForm.discountValue,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataForm,
                                                    "discountValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataForm.discountValue",
                                              },
                                            }),
                                          ]
                                        : [
                                            _c("el-input-number", {
                                              directives: [
                                                {
                                                  name: "discount-percent",
                                                  rawName: "v-discount-percent",
                                                },
                                              ],
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                min: 0,
                                                max: 100,
                                                precision: 0,
                                                "controls-position": "right",
                                              },
                                              model: {
                                                value:
                                                  _vm.dataForm.discountValue,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataForm,
                                                    "discountValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataForm.discountValue",
                                              },
                                            }),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm.discountAmount > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "erd-discount-amount" },
                                        [
                                          _vm._v(
                                            "\n                -" +
                                              _vm._s(
                                                _vm.formatMoney(
                                                  _vm.discountAmount
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Mô tả", prop: "description" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              placeholder: "Nhập mô tả...",
                            },
                            model: {
                              value: _vm.dataForm.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "description", $$v)
                              },
                              expression: "dataForm.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "sk-panel mb-4" },
            [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c(
                  "div",
                  { staticClass: "sk-panel-icon sk-panel-icon--warning" },
                  [_c("i", { staticClass: "el-icon-tickets" })]
                ),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Hóa đơn điện tử"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v("Cấu hình xuất hóa đơn điện tử cho khoản thu này"),
                  ]),
                ]),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Xuất hóa đơn điện tử",
                    prop: "issuingElectronicInvoices",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.dataForm.issuingElectronicInvoices,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.dataForm,
                            "issuingElectronicInvoices",
                            $$v
                          )
                        },
                        expression: "dataForm.issuingElectronicInvoices",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "sk-note sk-note--warning mb-4" }, [
            _c("i", { staticClass: "el-icon-warning-outline" }),
            _c("span", [
              _vm._v(
                "\n        Khoản thu mới sẽ được bổ sung vào các phiếu thu đã khởi tạo của " +
                  _vm._s(
                    _vm.scopeData.targetType === "GROUP" ? "nhóm" : "lớp"
                  ) +
                  " "
              ),
              _c("strong", [_vm._v(_vm._s(_vm.scopeData.targetName))]),
              _vm._v(" trong tháng "),
              _c("strong", [_vm._v(_vm._s(_vm.scopeData.month))]),
              _vm._v(" đợt "),
              _c("strong", [_vm._v(_vm._s(_vm.scopeData.turn))]),
              _vm._v(
                ". Phiếu “Chưa đóng 100%” nhận số lượng theo form và tính lại tiền; các trạng thái khác nhận số lượng và thành tiền bằng 0.\n      "
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }